export default function _pipe(f, g) {
  return function () {
    return g.call(this, f.apply(this, arguments));
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_pipe.js
// module id = 8778
// module chunks = 2